/** Query param carrying the dashboard's language into the setup app. */
export const ONBOARDING_LOCALE_PARAM = "locale";
